export default __webpack_public_path__ + "static/media/commentIcon.2afb28e6.svg";